$(document).ready(function () {
    // Focus the modal's first control with autofocus
    $('.modal').on('shown.bs.modal', function () {
        $(this).find('[autofocus]').focus();
    });
});
